import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import {
  ActivatablePackage,
  ActivationStatus,
  SelectedItem,
  SelectedItems,
  SortDirection,
} from '../../../core/interface';

@Component({
  selector: 'app-package-activation-table-component',
  templateUrl: './package-activation-table.component.html',
  styleUrls: ['./package-activation-table.component.scss'],
  standalone: false,
})
export class PackageActivationTableComponent implements OnChanges {
  @Input() activatablePackages: ActivatablePackage[];
  @Input() selectedItems: SelectedItems;
  @Input() showRestricted: boolean;
  @Input() hidePricing: boolean;

  @Output() sortChanged: EventEmitter<string> = new EventEmitter();
  @Output() packageCheckboxClicked: EventEmitter<SelectedItem[]> = new EventEmitter();

  sortIndicator = 'arrow_upward';
  private _nameSortOrder: SortDirection = 'ASCENDING';

  constructor(private readonly analyticsService: ProductAnalyticsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.activatablePackages) {
      const scrollLocation = document.querySelector('#package-header');
      if (scrollLocation) {
        scrollLocation.scrollIntoView();
      }
    }
  }

  private set nameSortOrder(sort: SortDirection) {
    this._nameSortOrder = sort;
    this.sortIndicator = sort === 'ASCENDING' ? 'arrow_upward' : 'arrow_downward';
  }

  private get nameSortOrder(): SortDirection {
    return this._nameSortOrder;
  }

  sortItems(): void {
    if (this.nameSortOrder === 'ASCENDING') {
      this.nameSortOrder = 'DESCENDING';
    } else {
      this.nameSortOrder = 'ASCENDING';
    }
    this.sortChanged.emit(this.nameSortOrder);
  }

  onPackageSelectionChanged(activatablePackage: ActivatablePackage): void {
    this.analyticsService.trackEvent('clicked-package-row-item', '', 'click');
    if (activatablePackage) {
      const selectedItems: SelectedItem[] = [];
      activatablePackage.activatableItemCount.forEach((item) => {
        if (
          (item.status === ActivationStatus.CANCELED && !item.isTrial) ||
          (item.status === ActivationStatus.ACTIVATED && !item.isTrial) ||
          (item.status === ActivationStatus.PENDING && !item.isTrial)
        ) {
          return;
        }
        if (item.activatableItem && item.activatableItem.appId && !item.activatableItem.restrictedReason) {
          let quantityToAdd = item.quantity;
          if (item.activatableItem.allowMultipleActivations && this.selectedItems) {
            const tempQuantity = this.selectedItems.get(item.activatableItem.appId)
              ? this.selectedItems.get(item.activatableItem.appId).quantity
              : undefined;
            if (tempQuantity !== undefined) {
              quantityToAdd = quantityToAdd + tempQuantity;
            }
          }
          selectedItems.push({
            appId: item.activatableItem.appId,
            editionId: item.editionId || '',
            quantity: quantityToAdd,
          });
        }
      });
      this.packageCheckboxClicked.emit(selectedItems);
    }
  }
}
